import { render, staticRenderFns } from "./QueuesTagEditModal.vue?vue&type=template&id=982c1038&scoped=true"
import script from "./QueuesTagEditModal.vue?vue&type=script&lang=js"
export * from "./QueuesTagEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "982c1038",
  null
  
)

export default component.exports